module.exports = __webpack_public_path__ + "img/0Q3A5610_L_Wood_MockedUp.312c9891.jpg";